import { AutogenLayoutCommissionsProcessingVoid } from "./autogen/AutogenLayoutCommissionsProcessingVoid";
import { TableRowDisplayEvent } from "@mcleod/components";
import { CommissionsProcessingUtil } from "./CommissionsProcessingUtil";
import { ModelRow } from "@mcleod/core";
import { ArchiveVoidedCommissions } from "./ArchiveVoidedCommissions";
import { FilterPanel } from "@mcleod/dispatch";
import { CommissionsProcessingTaskFilter } from "./CommissionsProcessingTaskFilter";

export class CommissionsProcessingVoid extends AutogenLayoutCommissionsProcessingVoid {
    public filterPanel: FilterPanel;
    public getPayees: () => ModelRow[] = () => [];

    onLoad(): void | Promise<void> {
        this.filterPanel = new FilterPanel([CommissionsProcessingTaskFilter.ORDER_BILLED, CommissionsProcessingTaskFilter.OVERRIDE_RATE], this.tableCommissionsProcessing, this.panelTaskFilters);
        this.tableCommissionsProcessing.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            tableRow.forEveryChildComponent((component) => {
                CommissionsProcessingUtil.setTooltipContent(component, tableRow.data);
            });
            CommissionsProcessingUtil.setComponentDetails(tableRow);
        });
        this.tableCommissionsProcessing.doOnResolveRowEdit = (row) => {
            this.mainDataSource.search(this.mainDataSource.lastSearch);
            return null;
        }
        this.buttonArchive.addClickListener(() => {

            ArchiveVoidedCommissions.showSlideout({
                payees: this.getPayees(),
                afterArchive: () => {
                    this.mainDataSource.search(this.mainDataSource.lastSearch);
                }
            });
        });
    }

    getLayoutBaseFilter(row: ModelRow): boolean {
        return row.get("ready_to_pay_flag") == "V";
    }
}
